export default __webpack_public_path__ + "static/media/esg-summit-2024.45bbe828.jpg";